// extracted by mini-css-extract-plugin
export var phoneNumberInput = "_fy-0";